import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [animatedText, setAnimatedText] = useState('');
  const [funFactIndex, setFunFactIndex] = useState(0);

  const funFacts = [
    "⚡ Robots use sensors to see and feel the world around them!",
    "💻 Coding is like giving instructions to a robot friend!",
    "🔬 Robotics combines science, math, and engineering!",
    "🌟 Every great invention started with a simple idea!"
  ];

  useEffect(() => {
    const text = "Barn Bots";
    let index = 0;
    const timer = setInterval(() => {
      if (index <= text.length) {
        setAnimatedText(text.slice(0, index));
        index++;
      } else {
        clearInterval(timer);
      }
    }, 150);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setFunFactIndex((prev) => (prev + 1) % funFacts.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [funFacts.length]);

  const handleLearnMore = () => {
    navigate('/about');
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Welcome to <span className="highlight">{animatedText}</span></h1>
            <p>A robotics and coding team for grades 2-5, located in Hampton Falls, NH</p>
            <button className="cta-button" onClick={handleLearnMore}>Learn More</button>
          </div>
          <div className="hero-image">
            <img src="/barn-bots-logo.jpg" alt="Barn Bots Logo" />
          </div>
        </div>
        
        {/* Tech Background Pattern */}
        <div className="tech-pattern">
          <div className="pattern-grid"></div>
          <div className="pattern-lines"></div>
        </div>
      </section>

      {/* Fun Facts Section */}
      <section className="fun-facts">
        <div className="container">
          <h2>Did You Know?</h2>
          <div className="fun-fact-display">
            <div className="fun-fact-text">
              {funFacts[funFactIndex]}
            </div>
            <div className="fun-fact-indicators">
              {funFacts.map((_, index) => (
                <span 
                  key={index} 
                  className={`indicator ${index === funFactIndex ? 'active' : ''}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Interactive Elements Section */}
      <section className="interactive-elements">
        <div className="container">
          <h2>What We Do</h2>
          <div className="activity-grid">
            <div className="activity-card">
              <div className="activity-icon">⚡</div>
              <h3>Build Robots</h3>
              <p>Learn to assemble and program robots</p>
            </div>
            <div className="activity-card">
              <div className="activity-icon">{'</>'}</div>
              <h3>Write Code</h3>
              <p>Create programs to control our robots</p>
            </div>
            <div className="activity-card">
              <div className="activity-icon">◆</div>
              <h3>Solve Problems</h3>
              <p>Work together to overcome challenges</p>
            </div>
            <div className="activity-card">
              <div className="activity-icon">▢</div>
              <h3>Compete & Learn</h3>
              <p>Join robotics competitions and grow</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Join the Adventure?</h2>
            <p>Come learn robotics and coding with us in our barn!</p>
            <div className="cta-buttons">
              <button className="cta-button primary" onClick={handleLearnMore}>
                Learn More
              </button>
              <button className="cta-button secondary" onClick={() => navigate('/contact')}>
                Get in Touch
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
